/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
    interface PromiseConstructor {
        withResolvers<T>(): {
            promise: Promise<T>;
            reject: (reason?: any) => void;
            resolve: (value: PromiseLike<T> | T) => void;
        };
    }
}
if (!Promise.withResolvers) {
    Promise.withResolvers = function <T>() {
        let resolve: (value: PromiseLike<T> | T) => void = () => {};
        let reject: (reason?: any) => void = () => {};
        const promise = new Promise<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });

        return { promise, resolve, reject };
    };
}

export {};
